import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import type { MktEvent } from '@shared/types';

interface Props {
  event: MktEvent | null;
  onClose: () => void;
}

export const EventDetailDialog: React.FC<Props> = ({ event, onClose }) => {
  if (!event) return null;
  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Evento {event.event_type}</DialogTitle>
      <DialogContent>
        <Box
          component="pre"
          sx={{
            fontFamily: 'monospace',
            fontSize: '0.8rem',
            overflow: 'auto',
            bgcolor: 'grey.100',
            p: 2,
            borderRadius: 1,
          }}
        >
          {JSON.stringify(event, null, 2)}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Chiudi</Button>
      </DialogActions>
    </Dialog>
  );
};
